<script setup lang="ts">
/* eslint-env vue/setup-compiler-macros */
import Skeleton from 'primevue/skeleton';

export interface TabStat {
    id: string
    label: string
    value: string | number
}

withDefaults(defineProps<{
    stats: TabStat[]
    loading?: boolean
}>(), {
    loading: false,
});

function syncTruncationTooltip(event: Event) {
    const label = event.target as HTMLElement;
    const isTruncated = label.scrollWidth > label.clientWidth;

    label.title = isTruncated ? label.textContent?.trim() ?? '' : '';
}
</script>

<template>
    <div class="tab-stat-pills">
        <div
            v-for="stat in stats"
            :key="stat.id"
            class="tab-stat-pills__pill"
        >
            <span
                class="tab-stat-pills__label"
                @mouseenter="syncTruncationTooltip"
                @focusin="syncTruncationTooltip"
            >{{ stat.label }}</span>
            <Skeleton v-if="loading" width="72px" height="17px" border-radius="4px" />
            <span v-else class="tab-stat-pills__value">{{ stat.value }}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.tab-stat-pills {
    display: flex;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: 10px;

    &__pill {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 13px;
        min-width: 265px;
        height: 46px;
        padding: 0 20px;
        background: $white-color;
        border: 1px solid $border-gray-color;
        border-radius: 20px;
    }

    &__label {
        font-family: $font-family-archivo;
        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        color: rgba($black-color, 0.7);
    }

    &__value {
        font-family: $font-family-archivo;
        font-size: 16px;
        font-weight: 400;
        line-height: 17px;
        color: $black-color;
    }
}
</style>
